import React, { useEffect, useRef } from 'react';
import { Empty } from 'antd';
import PropTypes from 'prop-types';
import { EMPTY_IMAGE_PLACEHOLDER } from '../../../../const/system';
import appColors from '../../../../const/colors';



const HTMLPreview = ({ html = '', hasErrors = false }) => {
  const containerRef = useRef(null);

  const fillPlaceholdersWithHTML = (html) => html.replace(/{{(.*?)}}/g, (match, key, offset, str) => {

    const imgTagStart = str.lastIndexOf('<img', offset);
    const imgTagEnd = str.indexOf('>', imgTagStart);

    const hasImagePlaceholder = imgTagStart !== -1 && offset > imgTagStart && offset < imgTagEnd;

    if (hasImagePlaceholder) {
      return EMPTY_IMAGE_PLACEHOLDER;
    }

    if (key.toLowerCase().includes('text_color')) {
      return appColors.white;
    }
    if (key.toLowerCase().includes('background_color')) {
      return appColors.gray;
    }

    if (key.toLowerCase().includes('button')) {
      return `<span title="${key}">Button</span>`;
    }

    return `{{${key}}}`;
  });
  const wrapImagesInSpan = (html) => {
    return html.replace(/<img([^>]*)src=['"](\{\{[^}]+}})['"]([^>]*)>/g, (match, key, offset, str) => {
      return `<span style="position: absolute; top: 50px; left: 50%; width: 100%; transform: translate(-50%, -50%);">${offset}</span><img${key}src='${offset}'${str}></span>`;
    });
  };

  useEffect(() => {
    if (containerRef.current) {
      const updatedHtml = wrapImagesInSpan(html);

      containerRef.current.innerHTML = fillPlaceholdersWithHTML(updatedHtml);
    }
  }, [ containerRef, html ]);

  return (
    <div className="hp-text-center hp-mt-30 hp-mb-32">
      <div className="template-visualization-block ant-card" style={{ boxShadow: hasErrors ? '0 0 8px 0 #ff0022' : '0 0 8px 0 #223C505C' }}>
        {html ?
          <div ref={containerRef} /> :
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      </div>
    </div>
  );
};

HTMLPreview.propTypes = {
  html: PropTypes.string,
  hasErrors: PropTypes.bool,
};

export default HTMLPreview;
